import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Modal, Row, Select, Space, Table} from 'antd'
import {ISubscriptionData} from "../../../model/subscription.model"
import Column from "antd/es/table/Column"
import {Observable} from "rxjs"
import {pipe} from "fp-ts/function"
import * as OBS from 'fp-ts-rxjs/Observable'
import {IEvent} from "../../../model/event.model"
import {DisciplineType, disciplineTypeData} from "../../../model/discipline.model"
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../store";

import './subscriptions.page.css'
import {formatterDate} from "../../../util/date.formatter";
import {exportSchoolSubscriptions, exportSubscriptions} from "../../user/export-handler.service";
import * as RA from "fp-ts/ReadonlyArray";
import * as O from "fp-ts/Option";
import {ISchoolEventCost} from "../../../model/school.model";
import {fetchEvents} from "../../../service/event.service";
import {getSchoolTotalCostByEvent} from "../../../service/school.service";
import {deleteSubscription, fetchSubscriptions} from "../../../service/subscription.service";
import {notificationActions} from "../../../store/notification.state";
import {sequenceS} from "fp-ts/Apply";
import {useNavigate, useSearchParams} from "react-router-dom";


interface SubscriptionFilters {
    readonly eventId?: number,
    readonly disciplineType: DisciplineType
}

const SubscriptionsPage = () => {
    const [subscriptions, setSubscriptions] = useState([] as ReadonlyArray<ISubscriptionData>)
    const [currentSubscription, setCurrentSubscription] = useState<ISubscriptionData | undefined>(undefined)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [events, setEvents] = useState([] as ReadonlyArray<IEvent>)
    const [filters, setFilters] = useState({} as SubscriptionFilters)
    const [loading, setLoading] = useState(false)
    const [cost, setCost] = useState({} as ISchoolEventCost)

    const [form] = Form.useForm()

    const [searchParams] = useSearchParams()

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const school = useSelector((state: RootState) => state.school)
    const login = useSelector((state: RootState) => state.login)

    useEffect(() => {
        setLoading(true)

        fetchEvents(1).subscribe(values => {
            setEvents(values)
            setLoading(false)

            const eventIdString = searchParams.get('eventId');
            if (eventIdString) {
                const eventId = Number.parseFloat(eventIdString)

                pipe(
                    values,
                    RA.findFirst(value => value.id === eventId),
                    O.fold(
                        () => {
                        },
                        value => {
                            setFilters({
                                ...filters,
                                eventId
                            })

                            form.setFieldValue('eventId', getEventLabel(value))
                        })
                )


            }
        })
    }, [])

    useEffect(() => {
        if (filters.eventId) {
            retrieveCost()
        }
        if (filters.eventId && filters.disciplineType) {
            refreshData()
        }
    }, [filters.eventId, filters.disciplineType])

    const retrieveCost = () => {
        getSchoolTotalCostByEvent(filters.eventId!, school.id!)
            .subscribe(data => setCost(data))
    }

    const refreshData = () => {
        setSubscriptions([])
        setLoading(true)

        buildSubscriptionOBS().subscribe(data => {
            setSubscriptions(data)
            setLoading(false)
        })
    }

    const buildSubscriptionOBS = (): Observable<ReadonlyArray<ISubscriptionData>> => {
        const disciplineType = filters.disciplineType === 3 ? [3, 4, 5] : [filters.disciplineType]
        return fetchSubscriptions(school.id!, filters.eventId!, disciplineType)
    }

    const handleEventFilter = (eventId: number) => {
        setFilters({
                ...filters,
                eventId
            }
        )
    }

    const handleDisciplineTypeFilter = (disciplineType: DisciplineType) => {
        setFilters({
            ...filters,
            disciplineType
        })
    }

    const showModal = (subscription: ISubscriptionData) => {
        setCurrentSubscription(subscription)
        setIsModalOpen(true)
    }

    const handleDelete = () => {
        setLoading(true)
        setIsModalOpen(false)
        pipe(
            deleteSubscription(currentSubscription!.id),
            OBS.chain(() => pipe({
                    cost: getSchoolTotalCostByEvent(filters.eventId!, school.id!),
                    subscriptions: buildSubscriptionOBS()
                },
                sequenceS(OBS.Monad)))
        ).subscribe(data => {
            dispatch(notificationActions.success("Cancellazione avvenuta con successo"))
            setSubscriptions(data.subscriptions)
            setCost(data.cost)
            setLoading(false)
        })
    }

    const handleCancel = () => {
        setIsModalOpen(false)
    }

    const getDataToDelete = (): string => {
        switch (filters.disciplineType) {
            case 1:
                return currentSubscription?.competitor1 + ""
            case 2:
                return currentSubscription?.competitor1 + " e " + currentSubscription?.competitor2
            case 3:
            case 4:
            case 5:
                return currentSubscription?.groupName + ""
        }
    }

    const retrieveEventNameFromFilter = (): string => {
        return pipe(
            events,
            RA.findFirst(event => event.id === filters.eventId!),
            O.map(event => event.description),
            O.getOrElse(() => " - ")
        )
    }

    const locale = {
        triggerAsc: 'Clicca per ordinare in modo ascendente',
        triggerDesc: 'Clicca per ordinare in modo discendente'
    }

    const getEventLabel = (item: IEvent) => formatterDate(item.date) + " - " + item.description

    const navigateToOnlineSubscription = () => {
        navigate(`/event/${filters.eventId}/subscription/second-step`)
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <Form
                        form={form}
                        layout="vertical"
                        size="middle"
                        name="filtersForm"
                    >
                        <Row gutter={100} justify="center" className="subscriptions-header-container">
                            <Col xs={24} md={12} style={{alignContent: "center", marginBottom:"10px"}}>
                                {
                                    filters.eventId && (
                                        <div>
                                            {
                                                cost && cost.cost > 0 && (
                                                    <h3 style={{margin: "0", textAlign: "center"}}>Totale
                                                        iscrizioni:&nbsp;{Number(cost.cost).toFixed(2)}€.&nbsp;{cost.iban}</h3>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </Col>
                            <Col xs={24} sm={12}>
                                {
                                    filters.eventId && (
                                        <div className="subscriptions buttons-container">
                                            {
                                                (login.user?.eventOwner === filters.eventId || login.user?.authority === "ROLE_ADMIN") &&
                                                <Button
                                                    type="default"
                                                    onClick={() => exportSubscriptions(dispatch, filters.eventId!, retrieveEventNameFromFilter())}>
                                                    Download riepilogo evento
                                                </Button>
                                            }
                                            <Button type="default"
                                                    onClick={() => exportSchoolSubscriptions(dispatch, filters.eventId!, school, retrieveEventNameFromFilter())}>
                                                Download riepilogo iscrizioni proprie
                                            </Button>
                                            <Button type="primary" onClick={navigateToOnlineSubscription}>
                                                Iscrizioni online
                                            </Button>
                                        </div>
                                    )
                                }
                            </Col>
                        </Row>
                        <Row gutter={100} justify="space-between">
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Evento"
                                    key={"eventId"}
                                    name="eventId"
                                >
                                    <Select
                                        placeholder="Seleziona un evento"
                                        options={events.map((item) => ({
                                            label: getEventLabel(item),
                                            value: item.id
                                        }))}
                                        onChange={(value) => handleEventFilter(value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Tipologia"
                                    key={"type"}
                                    name="type"
                                >
                                    <Select
                                        placeholder="Seleziona un tipo di disciplina"
                                        options={disciplineTypeData.map((item) => ({
                                            label: item.label,
                                            value: item.type
                                        }))}
                                        onChange={(value) => handleDisciplineTypeFilter(value)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                </div>
                <div>
                    <Table
                        id="subscriptionsTable"
                        scroll={{x: "max-content"}}
                        dataSource={subscriptions}
                        loading={loading}
                        rowKey={(record) => record.id + ' ' + Math.random()}
                        locale={locale}
                        pagination={{position: ['bottomCenter']}}>
                        {filters.disciplineType !== 3 && filters.disciplineType !== 4 && filters.disciplineType !== 5 && (
                            <>
                                {filters.disciplineType === 1 && (<>
                                    <Column title="Atleta" dataIndex="competitor1" key="competitor1"
                                            sorter={(a: ISubscriptionData, b: ISubscriptionData) => a.competitor1!.localeCompare(b.competitor1!)}
                                            sortDirections={['ascend', 'descend', 'ascend']}/>
                                </>)}
                                {filters.disciplineType === 2 && (<>
                                    <Column title="Primo Atleta" dataIndex="competitor1" key="competitor1"
                                            sorter={(a: ISubscriptionData, b: ISubscriptionData) => a.competitor1!.localeCompare(b.competitor1!)}
                                            sortDirections={['ascend', 'descend', 'ascend']}/>
                                    <Column title="Secondo Atleta" dataIndex="competitor2" key="competitor2"
                                            sorter={(a: ISubscriptionData, b: ISubscriptionData) => a.competitor2!.localeCompare(b.competitor2!)}
                                            sortDirections={['ascend', 'descend', 'ascend']}/>
                                </>)}
                            </>
                        )}
                        {(filters.disciplineType === 3 || filters.disciplineType === 4 || filters.disciplineType === 5) && (
                            <Column title="Gruppo - Nome coreografia - Numero atleti" dataIndex="groupName"
                                    key="groupName"
                                    sorter={(a: ISubscriptionData, b: ISubscriptionData) => a.groupName!.localeCompare(b!.groupName!)}
                                    sortDirections={['ascend', 'descend', 'ascend']}/>
                        )}
                        <Column title="Disciplina" dataIndex="discipline" key="discipline"
                                sorter={(a: ISubscriptionData, b: ISubscriptionData) => a.discipline!.localeCompare(b.discipline!)}
                                sortDirections={['ascend', 'descend', 'ascend']}/>
                        <Column title="Categoria" dataIndex="category" key="category"/>
                        <Column title="Classe" dataIndex="class" key="class" align={"center"}/>
                        {(filters.disciplineType === 1 || filters.disciplineType === 2) && (
                            <>
                                <Column title="Nome coreografia" dataIndex="choreographyName" key="choreographyName"/>
                            </>
                        )}
                        <Column title="Costo" dataIndex="cost" key="cost" align={"right"}
                                render={value => Number(value).toFixed(2) + ' €'}/>
                        <Column
                            key="action"
                            render={(value) => (
                                <Space size="middle">
                                    <a onClick={() => showModal(value)}>Cancella</a>
                                </Space>
                            )}
                        />
                    </Table>
                </div>
            </div>
            {
                currentSubscription &&
                (<Modal title="Cancella iscrizione" open={isModalOpen} onOk={handleDelete} onCancel={handleCancel}>
                    <div>
                        <span>Sei sicuro di voler cancellare l'iscrizione di </span>
                        <strong>{getDataToDelete()}</strong>
                    </div>
                    <div>
                        <span> dalla </span>
                        <strong>{currentSubscription.discipline} {currentSubscription.category} {currentSubscription.class}</strong>
                    </div>
                    <div>
                        <span> della gara </span>
                        <strong>{retrieveEventNameFromFilter()}</strong>
                        <span>?</span>
                    </div>
                </Modal>)
            }
        </>
    )
}

export default SubscriptionsPage